<template>
  <div class="inline-flex">
    <input ref="uploader" id="uploader" type="file" accept="image/*"
      @change="onFilesChange"
      direct_upload="true"
      class="d-none" 
    />
    <button @click="$refs.uploader.click()"
      class='btn btn-primary btn-small'>
      <i v-if="loading" class="fa fa-spinner fa-spin mr-2"></i>
      Update Image
    </button>
  </div>
</template>

<script>
  import { DirectUpload } from '@rails/activestorage';
  
  export default {

    data () {
      return {
        loading: false
      }
    },

    methods: {
      onFilesChange() {
        let input = this.$refs.uploader
        Array.from(input.files).forEach(file => this.uploadFile(file))
      },

      uploadFile(file) {
        if (file.name.includes('.jfif')) {
          Alert.show('error', 'JFIF image format is not supported')
          return
        }

        const self = this;
        let input = this.$refs.uploader;
        this.loading = true;
        const upload = new DirectUpload(file, '/api/v1/direct_uploads');
        upload.create((error, blob) => {
          if (error) {
            // Handle the error
          } else {
            setTimeout(() => { self.loading = false; }, 1000);
            self.$emit('file-upload', blob);
          }
        })
      }
    }
  }
</script>